/**
 * @file: 为选中的cube加选中高亮样式
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import SelectStore from './store/index';
import { flowAsync, startAnimation } from './flowBorder';

export function addAllSelectStyle(): void {
    let allSelectCubeIds: Array<string> = SelectStore.getAll();

    allSelectCubeIds.forEach((cubeId) => {
        let cube: CubeNode = CubeTree.findByCubeId(cubeId);

        if (cube.jView) {
            cube.jView.addClass('cube--selected');
        }
    });
    flowAsync();
}

export function cubeAddSelectStyle(cubeIds: CubeId[]): void {
    cubeIds.forEach((cubeId: CubeId): void => {
        let cube: CubeNode = CubeTree.findByCubeId(cubeId);
        let $el: JQuery<HTMLElement> = cube.jView;

        if ($el && !$el.hasClass('cube--selected')) {
            $el.addClass('cube--selected');
        }
    });
    flowAsync();
}

export function removeAllSelectStyle(): void {
    let allSelectCubeIds: Array<string> = SelectStore.getAll();

    allSelectCubeIds.forEach((cubeId) => {
        let cube: CubeNode = CubeTree.findByCubeId(cubeId);

        cube.jView && cube.jView.removeClass('cube--selected');
    });
    startAnimation(allSelectCubeIds);
}

export function cubeRemoveSelectStyle(cubeIds: CubeId[]): void {
    cubeIds.forEach((cubeId: CubeId): void => {
        let cube: CubeNode = CubeTree.findByCubeId(cubeId);
        let $el: JQuery<HTMLElement> = cube.jView;

        if ($el && $el.hasClass('cube--selected')) {
            $el.removeClass('cube--selected');
        }
    });
    startAnimation(cubeIds);
}

export default {
    addAllSelectStyle,
    removeAllSelectStyle,
    cubeAddSelectStyle,
    cubeRemoveSelectStyle
}
